// extracted by mini-css-extract-plugin
export var buttonSkeleton = "ApplePayPrimaryView-module--buttonSkeleton--8f40b";
export var fields = "ApplePayPrimaryView-module--fields--74bd2";